export const JIANYING_JOB_STATUS = Object.freeze({
  QUEUED: 'Queued',
  GENERATING_DRAFT: 'GeneratingDraft',
  DRAFT_READY: 'DraftReady',
  EXPORTING: 'Exporting',
  EXPORTED: 'Exported',
  UPLOADING: 'Uploading',
  SUCCESS: 'Success',
  FAILED: 'Failed',
});

export const JIANYING_JOB_STATUS_LABELS = Object.freeze({
  [JIANYING_JOB_STATUS.QUEUED]: '等待处理',
  [JIANYING_JOB_STATUS.GENERATING_DRAFT]: '生成草稿中',
  [JIANYING_JOB_STATUS.DRAFT_READY]: '等待导出',
  [JIANYING_JOB_STATUS.EXPORTING]: '剪映导出中',
  [JIANYING_JOB_STATUS.EXPORTED]: '等待上传',
  [JIANYING_JOB_STATUS.UPLOADING]: '上传成片中',
  [JIANYING_JOB_STATUS.SUCCESS]: '已完成',
  [JIANYING_JOB_STATUS.FAILED]: '失败',
});

export const JIANYING_ACTIVE_JOB_STATUSES = new Set([
  JIANYING_JOB_STATUS.QUEUED,
  JIANYING_JOB_STATUS.GENERATING_DRAFT,
  JIANYING_JOB_STATUS.DRAFT_READY,
  JIANYING_JOB_STATUS.EXPORTING,
  JIANYING_JOB_STATUS.EXPORTED,
  JIANYING_JOB_STATUS.UPLOADING,
]);

export const getJianyingJobStatusLabel = (status) =>
  JIANYING_JOB_STATUS_LABELS[status] || status || '-';

export const getJianyingStatusTone = (status) => {
  if (status === JIANYING_JOB_STATUS.SUCCESS) return 'success';
  if (status === JIANYING_JOB_STATUS.FAILED) return 'danger';
  if (status === JIANYING_JOB_STATUS.QUEUED) return 'muted';
  return 'progress';
};
